'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { MarkdownEditor, type MarkdownEditorProps } from '../MarkdownEditor';
import { FullscreenWrapper } from './FullscreenWrapper';
export const FullscreenMarkdownEditor: React.FC<MarkdownEditorProps> = props => {
  const $ = _c(7);
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const resolvedSingleView = props.singleView ?? isMobile;
  const markdownOnly = props.markdownOnly ?? false;
  let t0;
  if ($[0] !== props || $[1] !== resolvedSingleView) {
    t0 = <MarkdownEditor {...props} singleView={resolvedSingleView} />;
    $[0] = props;
    $[1] = resolvedSingleView;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== markdownOnly || $[4] !== resolvedSingleView || $[5] !== t0) {
    t1 = <FullscreenWrapper singleView={resolvedSingleView} markdownOnly={markdownOnly}>{t0}</FullscreenWrapper>;
    $[3] = markdownOnly;
    $[4] = resolvedSingleView;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};